import { type RunHandle, type Runner, type RunRequest, startRun } from "@codeshare/runner-core";

export { formatArgs, inspect } from "./inspect";

/** Runs JavaScript and TypeScript (types stripped with sucrase) in a module worker. */
export const javascriptRunner: Runner = {
  id: "javascript",
  name: "JavaScript / TypeScript",
  tests: "*.test.ts / *.spec.js files: describe/it/test/expect, or node:test and node:assert",
  run(request: RunRequest, options: { timeoutMs?: number } = {}): RunHandle {
    return startRun({
      createWorker: () =>
        new Worker(new URL("./js.worker.ts", import.meta.url), { type: "module" }),
      request,
      ...options,
    });
  },
};
